module.exports = __webpack_public_path__ + "static/media/grzanie.321d60cb.svg";